module.exports = __webpack_public_path__ + "static/media/invesdor-logo.ed48cae8.svg";